import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "checklist" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "checklist-main-content" }
const _hoisted_4 = {
  key: 0,
  class: "checklist-index"
}
const _hoisted_5 = {
  key: 1,
  class: "checklist-index-completed"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "20",
  viewBox: "0 0 40 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M38.3966 3.09703L34.9485 0.75328C33.9945 0.107245 32.6874 0.355144 32.0489 1.30166L15.1469 26.2265L7.37943 18.4591C6.56813 17.6478 5.24602 17.6478 4.43472 18.4591L1.4825 21.4113C0.671199 22.2226 0.671199 23.5447 1.4825 24.3636L13.4266 36.3077C14.0952 36.9762 15.1469 37.4871 16.0934 37.4871C17.0399 37.4871 17.9939 36.8936 18.6099 35.9997L38.9524 5.98916C39.5985 5.04264 39.3506 3.74306 38.3966 3.09703Z",
    fill: "#5972B7"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "checklist-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "16",
  viewBox: "0 0 22 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 15.6998L22 7.17481V0.299805L11 8.71481L0 0.299805V7.17481L11 15.6998Z",
    fill: "#575757"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "subchecklist-index"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "subchecklist-dot" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "subchecklist-index-completed"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "20",
  viewBox: "0 0 40 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M38.3966 3.09703L34.9485 0.75328C33.9945 0.107245 32.6874 0.355144 32.0489 1.30166L15.1469 26.2265L7.37943 18.4591C6.56813 17.6478 5.24602 17.6478 4.43472 18.4591L1.4825 21.4113C0.671199 22.2226 0.671199 23.5447 1.4825 24.3636L13.4266 36.3077C14.0952 36.9762 15.1469 37.4871 16.0934 37.4871C17.0399 37.4871 17.9939 36.8936 18.6099 35.9997L38.9524 5.98916C39.5985 5.04264 39.3506 3.74306 38.3966 3.09703Z",
    fill: "#5972B7"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "subchecklist-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.checklist, (check, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["checklist-check", {completed: $setup.isStepComplete(idx,check.description), current: $setup.isCurrent(check), 'policy-selected': $setup.isCurrent(check) && check.description == 'Policies' ,available: $setup.checkIfAvailable(idx), marginBottom: check.description === 'Policies' && $setup.showPolicies }]),
        onClick: ($event: any) => ($setup.routeToChecklist(check.description, idx)),
        key: idx
      }, [
        _createElementVNode("div", _hoisted_3, [
          (!$setup.isStepComplete(idx,check.description))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(check.description), 1),
            (check.description === 'Policies')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["policy-chevy", {'rotated': $setup.showPolicies}])
                }, _hoisted_10, 2))
              : _createCommentVNode("", true),
            (check.subList && $setup.showPolicies)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "sub-checklist",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(check.subList, (subCheck, subIdx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: subIdx }, [
                      ($setup.filterApplies(subCheck.filter))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["checklist-check sub-check", { selected: $setup.selectedPolicy == subCheck.value, available:$setup.checkIfAvailable(3) }]),
                            onClick: _withModifiers(($event: any) => ($setup.openPolicy(subCheck.value)), ["stop"])
                          }, [
                            (!$setup.isPolicyComplete(subIdx))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(subCheck.description), 1)
                          ], 10, _hoisted_11))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}